import * as network from "./network";

const fetchMenu = () => {
  return network.get(`menu`);
};

export default {
  fetchMenu,
};
